import Loading from '../../../Common/Loading';
import { FamiliesPerMonth } from './FamiliesPerMonth';
import { FamiliesPerYear } from './FamiliesPerYear';
import { useFamilyAllowanceChartsDataContext } from './hooks/useFamilyAllowanceChartsDataContext';
import { TransferValuePerMonth } from './TransferValuePerMonth';
import { TransferValuePerYear } from './TransferValuePerYear';
import { AverageValuePerYear } from './AverageValuePerYear';
import { AverageValuePerMonth } from './AverageValuePerMonth';

export const Charts = () => {
    const { isLoading } = useFamilyAllowanceChartsDataContext();

    if (isLoading) {
        return (
            <Loading message="Devido ao alto volume de informações, essa operação pode levar alguns instantes." />
        );
    }

    return (
        <>
            <div className='chats-indicators-side-by-side-dashboards mb-3'>
                <FamiliesPerYear />
                <FamiliesPerMonth />
            </div>
            <div className='chats-indicators-side-by-side-dashboards mb-3'>
                <TransferValuePerYear />
                <TransferValuePerMonth />
            </div>
            <div className='chats-indicators-side-by-side-dashboards mb-3'>
                <AverageValuePerYear />
                <AverageValuePerMonth />
            </div>
        </>
    );
};
